import { Dialog, IDialog, SELECTORS as DIALOG_SELECTORS } from "../Dialog";

export interface IModal extends IDialog {
    content: string;
}

const SELECTORS = {
    BUTTON_BOX: ":scope > .button-box",
    BTN_OK: ":scope > button[data-ok]",
    BTN_CANCEL: ":scope > button[data-cancel]",
    BTN_CLOSE: ":scope > button[data-close]"
};

export class Modal extends Dialog implements IModal {
    protected templateId = "dialog-modal";

    protected modal = true;

    private btnBox: HTMLDivElement;
    private btnOk: HTMLButtonElement;
    private btnCancel: HTMLButtonElement;
    private btnClose: HTMLButtonElement;

    constructor(contentId: string) {
        super();
        this.content = contentId;
        this.btnBox = this.dialog.querySelector<HTMLDivElement>(SELECTORS.BUTTON_BOX);
        this.btnOk = this.btnBox.querySelector<HTMLButtonElement>(SELECTORS.BTN_OK);
        this.btnCancel = this.btnBox.querySelector<HTMLButtonElement>(SELECTORS.BTN_CANCEL);
        this.btnClose = this.btnBox.querySelector<HTMLButtonElement>(SELECTORS.BTN_CLOSE);
    }

    /**
     * render alert like modal
     */
    public render() {
        this.preventScroll();
        this.btnOk.remove();
        this.btnCancel.remove();
        this.btnClose.addEventListener(
            "pointerup",
            () => {
                this.close();
            },
            this.eventOpts
        );
        return super.render();
    }

    /**
     * render confirm like modal
     */
    public async confirm(): Promise<any> {
        this.btnClose.remove();
        const p = new Promise((resolve, reject) => {
            this.btnOk.addEventListener(
                "pointerup",
                () => {
                    this.close();
                    resolve(this);
                },
                this.eventOpts
            );

            document.addEventListener(
                "keydown",
                (e) => {
                    if (e.key === "Escape") {
                        reject(this);
                    }
                },
                this.eventOpts
            );

            this.btnCancel.addEventListener(
                "pointerup",
                () => {
                    this.close();
                    reject(this);
                },
                this.eventOpts
            );
        });
        super.render();
        return p;
    }

    /**
     * test alert like modal
     */
    public static test(): IModal {
        return new Modal("modal-test")?.render();
    }

    /**
     * test confirm like modal
     */
    public static async testConfirm(): Promise<any> {
        return await new Modal("modal-test")?.confirm();
    }

    /**
     * @inheritdoc
     */
    public set content(v: string) {
        const template = document.getElementById(v) as HTMLTemplateElement;
        const content = template.content.cloneNode(true) as HTMLDivElement;
        this.dialog.querySelector<HTMLDivElement>(DIALOG_SELECTORS.CONTENT).appendChild(content);
    }
}
